// src/microsoft-context/MicrosoftRedirectHandler.js
import React, { useContext, useEffect, useRef } from 'react';
import { AuthContext, AuthProvider } from 'react-oauth2-code-pkce';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import axios from '../../../../services/auth/jwt/config';
import JWTAuth from 'services/auth/jwt';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '@jumbo/constants/ActionTypes';
import { fetchError, fetchStart, fetchSuccess } from 'redux/actions';

import AuthWrapper from './AuthWrapper';
import ContentLoader from '../../ContentLoader';
import CmtImage from '../../../../@coremat/CmtImage';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { alpha } from '@material-ui/core/styles';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  authContent: {
    padding: 30,
    [theme.breakpoints.up('md')]: {
      order: 1,
      width: props => (props.variant === 'default' ? '50%' : '100%'),
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
}));

// ✅ Main login page content
const MicroSoftLoginPage = ({ variant = 'default', wrapperVariant = 'default' }) => {
  const classes = useStyles({ variant });
  const dispatch = useDispatch();
  const history = useHistory();
  const { logIn, token, authCode } = useContext(AuthContext);
  const getSSO = accessToken => {
    const bodyParameters = { accessToken };

    dispatch({ type: FETCH_START });
    dispatch(fetchStart());

    customAxios
      .post('/User/EntraToken', JSON.stringify(bodyParameters), { headers: authHeader() })
      .then(({ data }) => {
        const keysToRemove = [
          'token',
          'ROCP_token',
          'ROCP_refreshToken',
          'ROCP_idToken',
          'ROCP_tokenExpire',
          'ROCP_refreshTokenExpire',
          'ROCP_loginMethod',
          'PKCE_code_verifier',
          'ROCP_loginInProgress',
          'user',
        ];

        keysToRemove.forEach(key => localStorage.removeItem(key));
        dispatch({ type: FETCH_SUCCESS });

        if (data?.token) {
          localStorage.setItem('token', JSON.stringify(data));
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
          dispatch(fetchSuccess());
          dispatch(JWTAuth.getAuthUser(true, data.token));
          history.replace('/');
        } else {
          dispatch(fetchError(data?.error || 'Unknown error'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };

  useEffect(() => {
    if (!token && !authCode) {
      setTimeout(() => {
        logIn();
      }, 1000); // ✅ wait for 1 second before redirecting to login page
    }
  }, []);
  useEffect(() => {
    if (token && token != '') {
      getSSO(token);
    }
  }, [token]);
  return (
    <AuthWrapper variant={wrapperVariant}>
      <Button>Signing in to your Microsoft Account.... </Button>
    </AuthWrapper>
  );
};

const MicrosoftRedirectHandler = () => {
  return (
    <AuthProvider
      authConfig={{
        clientId: '3a1dccc0-ec5a-49c3-a774-c9a1ae0aaab2',
        authorizationEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
        tokenEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/token',
        redirectUri: 'https://logwatch.myreports.online/oauth-redirect',
        // redirectUri: 'http://localhost:3000/oauth-redirect',
        scope: 'openid profile email User.Read',
        autoLogin: false,
      }}>
      <MicroSoftLoginPage variant="standard" wrapperVariant="bgColor" />
    </AuthProvider>
  );
};

export default MicrosoftRedirectHandler;
